/* "Add set to cart" for mix-and-match sets: adds every game in the set with one /cart/add.js call,
   then refreshes and opens the cart drawer (or goes to /cart when there is no drawer). */
(function () {
  if (window.vsSetsInit) return;
  window.vsSetsInit = true;
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-set-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const ids = button.dataset.setAdd.split(',').filter(Boolean);
    const error = button.parentElement.querySelector('.vs-set-card__error');
    const routes = window.routes || {};
    const addUrl = (routes.cart_add_url || '/cart/add') + '.js';
    const cartUrl = routes.cart_url || '/cart';
    const drawer = document.querySelector('cart-drawer');
    const body = { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.adding;
    if (error) { error.hidden = true; error.textContent = ''; }
    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : button.dataset.error);
      if (drawer && typeof drawer.renderContents === 'function' && result.sections && Object.values(result.sections).every(Boolean)) {
        drawer.classList.remove('is-empty');
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);
        drawer.renderContents(result);
      } else {
        window.location.assign(cartUrl);
      }
    } catch (e) {
      if (error) { error.textContent = (e && e.message) || button.dataset.error; error.hidden = false; }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = button.dataset.label;
    }
  });
})();
